export { default } from './index.vue'



// WEBPACK FOOTER //
// ./packages/dof-diamond-tab/index.js